module.exports = __webpack_public_path__ + "static/media/unsplash-zappy-fuel-red.0c816c65.jpg";